import React from 'react';

interface HeaderTitleProps {
  text: string;
  className?: string;
}

const HeaderTitle: React.FC<HeaderTitleProps> = ({ text, className }) => {
  return (
    <div
      className={`${className} noto-13-medium inline-block rounded-[40px] bg-light-2 px-[21px] py-[11px] leading-none text-dark-6`}
    >
      {text}
    </div>
  );
};

export default HeaderTitle;
